module.exports = __webpack_public_path__ + "img/contact.e735c1fa.svg";